import React, { useState, useEffect } from "react";
import {
	Grid,
	Typography,
	Button,
	TextField,
	MenuItem,
	Table,
	TableBody,
	TableCell,
	TableContainer,
	TableHead,
	TableRow,
	Paper,
	TablePagination,
	Dialog,
	DialogActions,
	DialogContent,
	DialogContentText,
	DialogTitle,
	Checkbox,
	FormControlLabel
} from "@mui/material";
import SearchIcon from "@mui/icons-material/Search";
import { NavLink } from "react-router-dom";
import Layout from "../../components/Wrappers/Layout";
import { Card, Alert } from "reactstrap";
import { AiOutlineSearch } from "react-icons/ai";
import { useSelector, useDispatch } from "react-redux";
import NotificationPopups from "../../NotificationPopup/NotificationPopups";
import { makeStyles } from "@mui/styles";
import { getRoleList } from "../../redux/actions/getRoleListAction";
import { getRoleListV1 } from "../../redux/actions/getRoleListV1Action";
import { getParentRoleList } from "../../redux/actions/getParentRoleListAction";
import { addOrUpdateRole } from "../../redux/actions/addOrUpdateRoleAction";
import CustomButton from "../../../src/components/CustomButton/CustomButton";
import EditIcon from "@mui/icons-material/Edit";
import VisibilityIcon from "@mui/icons-material/Visibility";
import success from "../../assets/img/success.png";
import failed from "../../assets/img/failed.png";
import LoadingSpinner from "../../components/LoadingSpinner/LoadingSpinner";
import "../../components/LoadingSpinner/spinner.css";
import regenerateToken from "../../components/RegenerateToken/regenerateToken";
import SOLogout from "../../components/Logout/SOLogout";
import val from "../../getThemeDetails"
const useStyles = makeStyles({
	table: {
		minWidth: 650
	}
});

const AdminRoleManagement = () => {
	const [roleSearch, setRoleSearch] = useState("");
	const [showParentRole, setShowParentRole] = useState(false);
	const [page, setPage] = useState(0);
	const [editOpen, setEditOpen] = React.useState(false);
	const [viewOpen, setViewOpen] = React.useState(false);
	const [addOpen, setAddOpen] = React.useState(false);
	const [rowsPerPage, setRowsPerPage] = useState(5);

	const [isLoading, setIsLoading] = useState(false);

	const [getRoleStatus, setGetRoleStatus] = useState(false);
	const [getRoleResArray, setGetRoleResArray] = useState([]);

	const [getRoleV1Status, setGetRoleV1Status] = useState(false);
	const [getRoleV1ResArray, setGetRoleV1ResArray] = useState([]);

	const [getParentRoleStatus, setGetParentRoleStatus] = useState(false);
	const [getParentRoleResArray, setGetParentRoleResArray] = useState([]);

	const [addOrUpdateRoleStatus, setAddOrUpdateRoleStatus] = useState(false);
	const [addOrUpdateRoleResArray, setAddOrUpdateRoleResArray] = useState([]);
	const [notificationOpen, setNotificationOpen] = React.useState(false);

	const view = "view";
	const edit = "edit";

	// const partnerloginUser = useSelector(({ login }) => login);
	// var authToken = partnerloginUser.data.AuthToken;
	const regenerateTokenRes = useSelector(
		({ regenerateToken }) => regenerateToken
	);
	var authToken = regenerateTokenRes.data.AuthToken;
	const classes = useStyles();
	const dispatch = useDispatch();

	const [user, setUser] = useState({
		roleId: "",
		role: "",
		userType: "",
		storeRequired: "",
		isWalletRequired: "",
		geoMapping: "",
		subRole: "",
		parentRole: ""
	});

	const {
		roleId,
		role,
		userType,
		storeRequired,
		isWalletRequired,
		geoMapping,
		subRole,
		parentRole
	} = user;

	const onInputChange = (e) => {
		setUser({ ...user, [e.target.name]: e.target.value });
		const m = /^([0-9A-Za-z]+\s?)*$/;
		if (e.target.name == "subRole") {
			if (e.target.value == "Y") {
				setShowParentRole(true);
			} else {
				setShowParentRole(false);
				setUser({ ...user, parentRole: "", subRole: "N" });
			}
		}

		if (e.target.name == "role") {
			setUser({
				...user,
				[e.target.name]: m.test(e.target.value)
					? e.target.value
					: user[e.target.name]
			});
		}
	};

	const getRoleListRes = useSelector(({ getRoleList }) => getRoleList);

	const getRoleListV1Res = useSelector(({ getRoleListV1 }) => getRoleListV1);

	const getParentRoleListRes = useSelector(
		({ getParentRoleList }) => getParentRoleList
	);

	const addOrupdateRoleRes = useSelector(
		({ addOrUpdateRole }) => addOrUpdateRole
	);

	const handleNoticationClose = () => {
		setNotificationOpen(false);
	};

	const handleChange = ({ target: { name, value } }) => {
		if (name === "Role") {
			setRoleSearch(value == "Select Role" ? "" : value);
		}
	};

	const getRoleListStatusFunc = () => {
		if (getRoleStatus) {
			if (getRoleListRes.data.status == "success") {
				setGetRoleResArray([].concat(getRoleListRes.data.roleList));
			}
			if (getRoleListRes.data.status == "failed") {
				setGetRoleResArray(getRoleListRes.data);
				if (
					getRoleListRes.data.description == "session out"
				) {
					SOLogout(dispatch, authToken, regenerateTokenRes.data.partnerId);
				}
				if (
					getRoleListRes.data.description == "Authorization failed"
				) {
					regenerateToken(dispatch, authToken, regenerateTokenRes.data.partnerId);
				}
			}
		}
	};

	useEffect(() => {
		getRoleListStatusFunc();
	}, [getRoleListRes.data.status]);

	const getRoleListReq = () => {
		setGetRoleStatus(true);
		dispatch(
			getRoleList(
				{
					ownerMasterRequestVO: {
						// adminId: 2,
						adminId: val.adminIDS,

						roleName: ""
					}
				},
				authToken
			)
		);
	};

	// useEffect(() => {
	// 	getRoleListReq();
	// }, []);

	useEffect(() => {
		if (regenerateTokenRes.data.status == "success") {
			getRoleListReq();
			getRoleListV1Req();
		}
	}, [regenerateTokenRes.data.status]);

	const getRoleListV1Req = () => {
		setGetRoleV1Status(true);
		setIsLoading(true);
		dispatch(
			getRoleListV1(
				{
					ownerMasterRequestVO: {
						// adminId: 2,
						adminId: val.adminIDS,

						roleName: roleSearch
					}
				},
				authToken
			)
		);
	};

	const getRoleListV1StatusFunc = () => {
		if (getRoleV1Status) {
			if (getRoleListV1Res.data.status == "success") {
				setGetRoleV1ResArray([].concat(getRoleListV1Res.data.roleMasterVOList));
				setIsLoading(false);
			}
			if (getRoleListV1Res.data.status == "failed") {
				setGetRoleV1ResArray(getRoleListV1Res.data);
				setIsLoading(false);
				NotificationPopups(
					"error",
					"Failed",
					getRoleListV1Res.data.description || getRoleListV1Res.description
				);
				if (
					getRoleListV1Res.data.description == "session out"
				) {
					SOLogout(dispatch, authToken, regenerateTokenRes.data.partnerId);
				}
				if (
					getRoleListV1Res.data.description == "Authorization failed"
				) {
					regenerateToken(dispatch, authToken, regenerateTokenRes.data.partnerId);
				}
			}
			if (getRoleListV1Res.data.status == "NOT FOUND") {
				setGetRoleV1ResArray(getRoleListV1Res.data);
				setIsLoading(false);
				NotificationPopups(
					"error",
					"NOT FOUND",
					getRoleListV1Res.data.description || getRoleListV1Res.description
				);
			}
			if (getRoleListV1Res.data.status == "INVALID REQUEST") {
				setGetRoleV1ResArray(getRoleListV1Res.data);
				setIsLoading(false);
				NotificationPopups(
					"error",
					"INVALID REQUEST",
					getRoleListV1Res.data.description || getRoleListV1Res.description
				);
			}
		}
	};

	useEffect(() => {
		getRoleListV1StatusFunc();
	}, [getRoleListV1Res.data.status]);

	const getParentRoleListReq = () => {
		setGetParentRoleStatus(true);
		dispatch(
			getParentRoleList(
				{
					ownerMasterRequestVO: {
						// adminId: 2,
						adminId: val.adminIDS,
						userType: userType
					}
				},
				authToken
			)
		);
	};

	const getParentRoleStatusFunc = () => {
		if (getParentRoleStatus) {
			if (getParentRoleListRes.data.status == "success") {
				setGetParentRoleResArray(
					[].concat(getParentRoleListRes.data.parentRoleList)
				);
			}
			if (getParentRoleListRes.data.status == "failed") {
				setGetParentRoleResArray([].concat(getParentRoleListRes.data));
				if (
					getParentRoleListRes.data.description == "session out"
				) {
					SOLogout(dispatch, authToken, regenerateTokenRes.data.partnerId);
				}
				if (
					getParentRoleListRes.data.description == "Authorization failed"
				) {
					regenerateToken(dispatch, authToken, regenerateTokenRes.data.partnerId);
				}
			}
		}
	};

	useEffect(() => {
		getParentRoleStatusFunc();
	}, [getParentRoleListRes.data.status]);

	const handleChangePage = (event, newPage) => {
		setPage(newPage);
	};

	const handleChangeRowsPerPage = (event) => {
		setRowsPerPage(parseInt(event.target.value, 10));
		setPage(0);
	};

	const handleClose = () => {
		setEditOpen(false);
		setViewOpen(false);
		setAddOpen(false);
		setShowParentRole(false);
		setUser({
			roleId: "",
			role: "",
			userType: "",
			storeRequired: "",
			isWalletRequired: "",
			geoMapping: "",
			subRole: "",
			parentRole: ""
		});
	};

	useEffect(() => {
		if (userType) {
			getParentRoleListReq();
		}
	}, [userType]);

	const setData = (row, fs) => {
		if (fs == "view") {
			setViewOpen(true);
		}
		if (fs == "edit") {
			setEditOpen(true);
		}
		if (row.subRole == "Y") {
			setShowParentRole(true);
		} else {
			setShowParentRole(false);
		}
		setUser({
			roleId: row.roleId,
			role: row.roleName,
			userType:
				row.ownerAccount == "Y"
					? "isOwnerACR"
					: "Select User Type" || row.walletAccount == "Y"
						? "isWalletACR"
						: "Select User Type",
			storeRequired: row.storeRequired,
			isWalletRequired: row.isWalletRequired,
			geoMapping: row.geoMapping,
			subRole: row.subRole,
			parentRole: row.parentRole
		});
	};

	const addOrUpdateRoleReqFunc = () => {
		setAddOpen(false);
		setEditOpen(false);
		setAddOrUpdateRoleStatus(true);
		const addOrUpdateRoleReq = {
			// adminId: 2,
			adminId: val.adminIDS,

			roleId: roleId,
			role: role,
			userType: userType,
			isStoreRequired: storeRequired,
			isWalletRequired: isWalletRequired,
			isGeoMapRequired: geoMapping,
			isSubroleRequired: subRole,
			isParentRole: parentRole
		};
		dispatch(addOrUpdateRole(addOrUpdateRoleReq, authToken));
	};

	const addOrUpdateRoleStatusFunc = () => {
		if (addOrUpdateRoleStatus) {
			if (addOrupdateRoleRes.data.status == "success") {
				setAddOrUpdateRoleResArray(addOrupdateRoleRes.data);
				setNotificationOpen(true);
				getRoleListV1Req();
				getRoleListReq();
			}
			if (addOrupdateRoleRes.data.status == "failed") {
				setAddOrUpdateRoleResArray(addOrupdateRoleRes.data);
				setNotificationOpen(true);
				if (
					addOrupdateRoleRes.data.description == "session out"
				) {
					SOLogout(dispatch, authToken, regenerateTokenRes.data.partnerId);
				}
				if (
					addOrupdateRoleRes.data.description == "Authorization failed"
				) {
					regenerateToken(dispatch, authToken, regenerateTokenRes.data.partnerId);
				}
			}
		}
	};

	useEffect(() => {
		addOrUpdateRoleStatusFunc();
	}, [addOrupdateRoleRes.data.status]);

	const addRole = () => {
		setAddOpen(true);
	};

	return (
		<>
			<Layout>
				<Card>
					<Grid
						container
						style={{
							padding: "10px",
							marginTop: "1rem",
							marginLeft: "1rem",
							gap: "10px"
						}}
					>
						<Grid item xs={12} md={5} sm={3} lg={7}></Grid>
						<Grid item xs={12} md={3} sm={3} lg={2}>
							{/* <Button
								variant="contained"
								style={{ backgroundColor: "#00b9f5", color: "white" }}
								size="small"
								onClick={() => addRole()}
							>
								Add New Role
							</Button> */}
							<CustomButton
								style={{
									padding: "8px"
								}}
								onClick={() => addRole()}

							>
								Add New Role
							</CustomButton>
						</Grid>
						<Grid item xs={12} md={3} sm={3} lg={2}>
							<NavLink to="/index/mapping-role">
								<CustomButton
									style={{
										padding: "8px"
									}}
									onClick={() => addRole()}

								>
									Mapping Role
								</CustomButton>

								{/* <Button
									variant="contained"
									style={{ backgroundColor: "#00b9f5", color: "white" }}
									size="small"
								>
									Mapping Role
								</Button> */}
							</NavLink>
						</Grid>
					</Grid>

					<Grid
						container
						spacing={2}
						style={{ padding: "25px", marginTop: "2rem" }}
					>
						<Grid item xs={12} sm={6} md={4} lg={4}>
							<TextField
								select
								size="small"
								color="primary"
								autoFocus={true}
								type="text"
								label="Role"
								fullWidth={true}
								variant="standard"
								name="Role"
								// value={roleSearch || "Select Role"}
								defaultValue={"Select Role" || roleSearch}
								onChange={handleChange}
								InputProps={{
									sx: {
										"&:before": { borderBottomColor: "gray" }, // before focus
										"&:after": { borderBottomColor: "gray" },  // after focus
									},
								}}
								InputLabelProps={{
									sx: { color: 'gray' }, // Optional: if you want the label to be white
								}}
							>
								<MenuItem value="Select Role" selected="Select Role">
									Select Role
								</MenuItem>
								{getRoleListRes.data.roleList &&
									getRoleResArray.map((x) => (
										<MenuItem value={x.role}>{x.role}</MenuItem>
									))}
							</TextField>
						</Grid>
						<Grid item xs={12} sm={6} md={4} lg={3}>
							<CustomButton
								style={{
									padding: "8px"
								}}
								onClick={getRoleListV1Req}

							>
								Search <SearchIcon />
							</CustomButton>
							{/* <Button
								style={{
									marginLeft: "0.7rem",
									backgroundColor: "#00b9f5",
									color: "white",
									marginTop: "9px"
								}}
								endIcon={<AiOutlineSearch />}
								variant="contained"
								onClick={getRoleListV1Req}
							>
								Search
							</Button> */}
						</Grid>
					</Grid>
				</Card>

				{isLoading ? (
					<LoadingSpinner />
				) : getRoleV1ResArray.length == undefined ||
					getRoleV1ResArray.status == "NOT FOUND" ||
					getRoleV1ResArray.status == "INVALID REQUEST" ||
					!getRoleV1Status ? (
					<Card>
						<Grid
							container
							style={{
								padding: "10px"
							}}
						>
							<Grid xs={12} sm={12} md={12} lg={12}>
								<Typography variant="body1" style={{ fontWeight: "700" }}
									className="themeText"

								>
									Report Table
								</Typography>
							</Grid>
							<Grid xs={12} sm={12} md={12} lg={12}>
								<Alert
									className="my-3 tableHeaderColor"
									variant="secondary"
								// style={{ backgroundColor: "#00b9f5", color: "white" }}
								>
									No Records Found!
								</Alert>
							</Grid>
						</Grid>
					</Card>
				) : (
					<Card>
						<Grid
							container
							style={{
								padding: "10px"
							}}
						>
							<Grid xs={12} sm={12} md={12} lg={12}>
								<Typography variant="body1" style={{ fontWeight: "700" }}
									className="themeText"

								>
									Report Table
								</Typography>
							</Grid>
							<TableContainer component={Paper} className="my-3">
								<Table
									className={classes.table}
									size="small"
									aria-label="a dense table"
								>
									<TableHead>
										<TableRow className="tableHeaderColor">

											<TableCell
												align="center"
												style={{ fontWeight: "bold", color: "white" }}
											>
												Role ID
											</TableCell>
											<TableCell
												align="center"
												style={{ fontWeight: "bold", color: "white" }}
											>
												Role
											</TableCell>
											<TableCell
												align="center"
												style={{ fontWeight: "bold", color: "white" }}
											>
												Is SubRole
											</TableCell>
											<TableCell
												align="center"
												style={{ fontWeight: "bold", color: "white" }}
											>
												Action
											</TableCell>
											{/* <TableCell
										align="center"
										style={{ fontWeight: "bold", color: "white" }}
									>
										Edit
									</TableCell> */}
										</TableRow>
									</TableHead>

									<TableBody>
										{getRoleV1ResArray &&
											[]
												.concat(getRoleV1ResArray)
												.slice(
													page * rowsPerPage,
													page * rowsPerPage + rowsPerPage
												)
												.map((row, index) => (
													<TableRow>
														<TableCell align="center">{row.roleId}</TableCell>
														<TableCell align="center">{row.roleName}</TableCell>
														<TableCell align="center">{row.subRole}</TableCell>

														<TableCell align="center">
															<CustomButton
																style={{
																	padding: "8px",
																	margin: "0 8px"
																}}
																onClick={() => setData(row, view)}
															>
																<VisibilityIcon style={{ color: "#fff" }} />
															</CustomButton>
															{/* </TableCell>
												<TableCell align="center"> */}
															<CustomButton
																style={{
																	padding: "8px"
																}}
																onClick={() => setData(row, edit)}
															>
																<EditIcon style={{ color: "#fff" }} />
															</CustomButton>
														</TableCell>
													</TableRow>
												))}
									</TableBody>
								</Table>
								<TablePagination
									rowsPerPageOptions={[5, 10, 25]}
									component="div"
									count={getRoleV1ResArray.length}
									rowsPerPage={rowsPerPage}
									page={page}
									onPageChange={handleChangePage}
									onRowsPerPageChange={handleChangeRowsPerPage}
								/>
							</TableContainer>
						</Grid>
					</Card>
				)}
				<div>
					<Dialog open={editOpen} onClose={handleClose}>
						<DialogTitle>Edit Role</DialogTitle>
						<DialogContent>
							<TextField
								required
								style={{ marginTop: "10px" }}
								size="small"
								color="primary"
								autoFocus={true}
								type="text"
								label="Role"
								fullWidth={true}
								name="role"
								value={role || ""}
								onChange={(e) => onInputChange(e)}
							></TextField>

							<TextField
								required
								style={{ marginTop: "10px" }}
								select
								size="small"
								color="primary"
								autoFocus={true}
								type="text"
								label="User Type"
								fullWidth={true}
								name="userType"
								defaultValue={userType || "Select User Type"}
								onChange={(e) => onInputChange(e)}
							>
								<MenuItem value="Select User Type" selected="Select User Type">
									Select User Type
								</MenuItem>
								<MenuItem value="isWalletACR">isFrontEndRequired</MenuItem>
								<MenuItem value="isOwnerACR">isBackEndRequired</MenuItem>
							</TextField>

							<TextField
								style={{ marginTop: "10px" }}
								select
								size="small"
								color="primary"
								autoFocus={true}
								type="text"
								label="Store Required"
								fullWidth={true}
								name="storeRequired"
								// value={storeRequired || "storeRequired"}
								defaultValue={storeRequired || "Select Store Required"}
								onChange={(e) => onInputChange(e)}
							>
								<MenuItem
									value="Select Store Required"
									selected="Select User Type"
								>
									Select Store Required
								</MenuItem>
								<MenuItem value="Y">Y</MenuItem>
								<MenuItem value="N">N</MenuItem>
							</TextField>

							<TextField
								style={{ marginTop: "10px" }}
								select
								size="small"
								color="primary"
								autoFocus={true}
								type="text"
								label="Is Wallet Required"
								fullWidth={true}
								name="isWalletRequired"
								// value={isWalletRequired || "Select Is Wallet Required"}
								defaultValue={isWalletRequired || "Select Is Wallet Required"}
								onChange={(e) => onInputChange(e)}
							>
								<MenuItem
									value="Select Is Wallet Required"
									selected="Select Is Wallet Required"
								>
									Select Is Wallet Required
								</MenuItem>
								<MenuItem value="Y">Y</MenuItem>
								<MenuItem value="N">N</MenuItem>
							</TextField>

							<TextField
								style={{ marginTop: "10px" }}
								select
								size="small"
								color="primary"
								autoFocus={true}
								type="text"
								label="Geo Mapping Required"
								fullWidth={true}
								name="geoMapping"
								// value={geoMapping || "Select Geo Mapping Required"}
								defaultValue={geoMapping || "Select Geo Mapping Required"}
								onChange={(e) => onInputChange(e)}
							>
								<MenuItem
									value="Select Geo Mapping Required"
									selected="Select Geo Mapping Required"
								>
									Select Geo Mapping Required
								</MenuItem>
								<MenuItem value="Y">Y</MenuItem>
								<MenuItem value="N">N</MenuItem>
							</TextField>

							<TextField
								style={{ marginTop: "10px" }}
								select
								size="small"
								color="primary"
								autoFocus={true}
								type="text"
								label="Is It A SubRole"
								fullWidth={true}
								name="subRole"
								// value={subRole || "subRole"}
								defaultValue={subRole || "Select SubRole"}
								onChange={(e) => onInputChange(e)}
							>
								<MenuItem value="Select SubRole" selected="Select SubRole">
									Select SubRole
								</MenuItem>
								<MenuItem value="Y">Y</MenuItem>
								<MenuItem value="N">N</MenuItem>
							</TextField>

							{showParentRole && (
								<TextField
									style={{ marginTop: "10px" }}
									select
									size="small"
									color="primary"
									autoFocus={true}
									type="text"
									label="Parent Role"
									fullWidth={true}
									name="parentRole"
									// value={parentRole || ""}
									defaultValue={parentRole || "Select Parent Role"}
									onChange={(e) => onInputChange(e)}
								>
									<MenuItem
										value="Select Parent Role"
										selected="Select Parent Role"
									>
										Select Parent Role
									</MenuItem>
									{getParentRoleResArray &&
										getParentRoleResArray.map((x) => (
											<MenuItem value={x.split("-")[0]}>{x}</MenuItem>
										))}
								</TextField>
							)}
						</DialogContent>
						<DialogActions style={{ padding: "14px" }}>
							<Button
								style={{
									backgroundColor: "#fff",
									color: "#000"
								}}
								variant="contained"
								onClick={handleClose}
							>
								Cancel
							</Button>
							<Button
								style={{
									backgroundColor: "#00b9f5",
									color: "white"
								}}
								variant="contained"
								onClick={addOrUpdateRoleReqFunc}
							>
								Save
							</Button>
						</DialogActions>
					</Dialog>
				</div>
				<div>
					<Dialog open={viewOpen} onClose={handleClose}>
						<DialogTitle>View Role</DialogTitle>
						<DialogContent>
							<TextField
								style={{ marginTop: "10px" }}
								size="small"
								color="primary"
								autoFocus={true}
								type="text"
								label="Role"
								fullWidth={true}
								name="role"
								value={role || ""}
								disabled={true}
							></TextField>

							<TextField
								style={{ marginTop: "10px" }}
								select
								size="small"
								color="primary"
								autoFocus={true}
								type="text"
								label="User Type"
								fullWidth={true}
								name="userType"
								value={userType || "Select User Type"}
								disabled={true}
							>
								<MenuItem value="Select User Type">Select User Type</MenuItem>
								<MenuItem value="isWalletACR">isFrontEndRequired</MenuItem>
								<MenuItem value="isOwnerACR">isBackEndRequired</MenuItem>
							</TextField>

							<TextField
								style={{ marginTop: "10px" }}
								select
								size="small"
								color="primary"
								autoFocus={true}
								type="text"
								label="Store Required"
								fullWidth={true}
								name="storeRequired"
								value={storeRequired || "storeRequired"}
								disabled={true}
							>
								<MenuItem value="storeRequired">Select Store Required</MenuItem>
								<MenuItem value="Y">Y</MenuItem>
								<MenuItem value="N">N</MenuItem>
							</TextField>

							<TextField
								style={{ marginTop: "10px" }}
								select
								size="small"
								color="primary"
								autoFocus={true}
								type="text"
								label="Is Wallet Required"
								fullWidth={true}
								name="isWalletRequired"
								value={isWalletRequired || "Select Is Wallet Required"}
								disabled={true}
							>
								<MenuItem value="Select Is Wallet Required">
									Select Is Wallet Required
								</MenuItem>
								<MenuItem value="Y">Y</MenuItem>
								<MenuItem value="N">N</MenuItem>
							</TextField>

							<TextField
								style={{ marginTop: "10px" }}
								select
								size="small"
								color="primary"
								autoFocus={true}
								type="text"
								label="Geo Mapping Required"
								fullWidth={true}
								name="geoMapping"
								value={geoMapping || "Select Geo Mapping Required"}
								disabled={true}
							>
								<MenuItem value="Select Geo Mapping Required">
									Select Geo Mapping Required
								</MenuItem>
								<MenuItem value="Y">Y</MenuItem>
								<MenuItem value="N">N</MenuItem>
							</TextField>

							<TextField
								style={{ marginTop: "10px" }}
								select
								size="small"
								color="primary"
								autoFocus={true}
								type="text"
								label="Is It A SubRole"
								fullWidth={true}
								name="subRole"
								value={subRole || "subRole"}
								disabled={true}
							>
								<MenuItem value="subRole">Select SubRole</MenuItem>
								<MenuItem value="Y">Y</MenuItem>
								<MenuItem value="N">N</MenuItem>
							</TextField>

							{showParentRole && (
								<TextField
									style={{ marginTop: "10px" }}
									select
									size="small"
									color="primary"
									autoFocus={true}
									type="text"
									label="Parent Role"
									fullWidth={true}
									name="parentRole"
									value={parentRole || ""}
									disabled={true}
								>
									<MenuItem value="">Select Parent Role</MenuItem>
									{getParentRoleResArray &&
										getParentRoleResArray.map((x) => (
											<MenuItem value={x.split("-")[0]}>{x}</MenuItem>
										))}
								</TextField>
							)}
						</DialogContent>
						<DialogActions>
							<Button
								style={{
									backgroundColor: "#00b9f5",
									color: "white"
								}}
								variant="contained"
								onClick={handleClose}
							>
								Close
							</Button>
						</DialogActions>
					</Dialog>
				</div>
				<div>
					<Dialog open={addOpen} onClose={handleClose}>
						<DialogTitle style={{ minWidth: "600px" }}>Add Role</DialogTitle>
						<DialogContent>
							<TextField
								required
								style={{ marginTop: "10px" }}
								size="small"
								color="primary"
								autoFocus={true}
								type="text"
								label="Role"
								fullWidth={true}
								name="role"
								value={role || ""}
								variant="standard"
								onChange={(e) => onInputChange(e)}
							></TextField>

							<TextField
								required
								style={{ marginTop: "10px" }}
								select
								size="small"
								color="primary"
								autoFocus={true}
								type="text"
								label="User Type"
								fullWidth={true}
								variant="standard"

								name="userType"
								defaultValue={"Select User Type" || userType}
								onChange={(e) => onInputChange(e)}
							>
								<MenuItem value="Select User Type" selected="Select User Type">
									Select User Type
								</MenuItem>
								<MenuItem value="isWalletACR">isFrontEndRequired</MenuItem>
								<MenuItem value="isOwnerACR">isBackEndRequired</MenuItem>
							</TextField>

							<TextField
								style={{ marginTop: "10px" }}
								select
								size="small"
								color="primary"
								autoFocus={true}
								type="text"
								label="Store Required"
								fullWidth={true}
								variant="standard"

								name="storeRequired"
								// value={storeRequired || "storeRequired"}
								defaultValue={"Select Store Required" || storeRequired}
								onChange={(e) => onInputChange(e)}
							>
								<MenuItem
									value="Select Store Required"
									selected="Select User Type"
								>
									Select Store Required
								</MenuItem>
								<MenuItem value="Y">Y</MenuItem>
								<MenuItem value="N">N</MenuItem>
							</TextField>

							<TextField
								style={{ marginTop: "10px" }}
								select
								size="small"
								color="primary"
								autoFocus={true}
								type="text"
								variant="standard"

								label="Is Wallet Required"
								fullWidth={true}
								name="isWalletRequired"
								// value={isWalletRequired || "Select Is Wallet Required"}
								defaultValue={"Select Is Wallet Required" || isWalletRequired}
								onChange={(e) => onInputChange(e)}
							>
								<MenuItem
									value="Select Is Wallet Required"
									selected="Select Is Wallet Required"
								>
									Select Is Wallet Required
								</MenuItem>
								<MenuItem value="Y">Y</MenuItem>
								<MenuItem value="N">N</MenuItem>
							</TextField>

							<TextField
								style={{ marginTop: "10px" }}
								select
								size="small"
								color="primary"
								autoFocus={true}
								type="text"
								variant="standard"

								label="Geo Mapping Required"
								fullWidth={true}
								name="geoMapping"
								// value={geoMapping || "Select Geo Mapping Required"}
								defaultValue={"Select Geo Mapping Required" || geoMapping}
								onChange={(e) => onInputChange(e)}
							>
								<MenuItem
									value="Select Geo Mapping Required"
									selected="Select Geo Mapping Required"
								>
									Select Geo Mapping Required
								</MenuItem>
								<MenuItem value="Y">Y</MenuItem>
								<MenuItem value="N">N</MenuItem>
							</TextField>

							<TextField
								style={{ marginTop: "10px" }}
								select
								size="small"
								color="primary"
								autoFocus={true}
								type="text"
								label="Is It A SubRole"
								fullWidth={true}
								name="subRole"
								variant="standard"

								// value={subRole || "subRole"}
								defaultValue={"Select SubRole" || subRole}
								onChange={(e) => onInputChange(e)}
							>
								<MenuItem value="Select SubRole" selected="Select SubRole">
									Select SubRole
								</MenuItem>
								<MenuItem value="Y">Y</MenuItem>
								<MenuItem value="N">N</MenuItem>
							</TextField>

							{showParentRole && (
								<TextField
									style={{ marginTop: "10px" }}
									select
									size="small"
									color="primary"
									autoFocus={true}
									type="text"
									label="Parent Role"
									fullWidth={true}
									name="parentRole"
									variant="standard"

									// value={parentRole || ""}
									defaultValue={"Select Parent Role" || parentRole}
									onChange={(e) => onInputChange(e)}
								>
									<MenuItem
										value="Select Parent Role"
										selected="Select Parent Role"
									>
										Select Parent Role
									</MenuItem>
									{getParentRoleResArray &&
										getParentRoleResArray.map((x) => (
											<MenuItem value={x.split("-")[0]}>{x}</MenuItem>
										))}
								</TextField>
							)}
						</DialogContent>
						<DialogActions style={{ padding: "14px" }}>
							<Button
								style={{
									backgroundColor: "#fff",
									color: "#000"
								}}
								variant="contained"
								onClick={handleClose}
							>
								Cancel
							</Button>
							<Button
								style={{
									backgroundColor: "#00b9f5",
									color: "white"
								}}
								variant="contained"
								onClick={addOrUpdateRoleReqFunc}
							>
								Save
							</Button>
						</DialogActions>
					</Dialog>
				</div>
			</Layout>

			{addOrUpdateRoleResArray.status == "success" && (
				<div>
					<Dialog open={notificationOpen} onClose={handleNoticationClose}>
						<DialogContent
							className="text-center"
							style={{ backgroundColor: "#00b9f51c" }}
						>
							<img src={success} alt="" width="100px" className="my-2" />
						</DialogContent>
						<DialogContent>
							<h4
								style={{ margin: "0", textAlign: "center", fontSize: "15px" }}
							>
								{addOrUpdateRoleResArray.description}
							</h4>
						</DialogContent>
						<DialogActions style={{ justifyContent: "center" }}>
							<Button
								style={{
									margin: "10px 0",
									backgroundColor: "#00b9f5",
									color: "white"
								}}
								variant="contained"
								onClick={handleNoticationClose}
							>
								Ok
							</Button>
						</DialogActions>
					</Dialog>
				</div>
			)}

			{addOrUpdateRoleResArray.status == "failed" && (
				<div>
					<Dialog open={notificationOpen} onClose={handleNoticationClose}>
						<DialogContent
							className="text-center"
							style={{ backgroundColor: "#00b9f51c" }}
						>
							<img src={failed} alt="" width="100px" className="my-2" />
						</DialogContent>
						<DialogContent>
							<h4
								style={{ margin: "0", textAlign: "center", fontSize: "15px" }}
							>
								{addOrUpdateRoleResArray.description}
							</h4>
						</DialogContent>
						<DialogActions style={{ justifyContent: "center" }}>
							<Button
								style={{
									margin: "10px 0",
									backgroundColor: "#00b9f5",
									color: "white"
								}}
								variant="contained"
								onClick={handleNoticationClose}
							>
								Ok
							</Button>
						</DialogActions>
					</Dialog>
				</div>
			)}
		</>
	);
};

export default AdminRoleManagement;
